import BaseRVModule from "./RVModule";

class RVModule extends BaseRVModule {

}

const rvModule = new RVModule();
export default rvModule;
